import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './SidebarMaster';
import MobileMenuButton from '../MobileMenuButton';

// Demo-Badge: Dezenter Hinweis unten rechts für Demo-Organisation
// Nicht störend auf Screenshots, aber intern eindeutig erkennbar
const DemoBadge = () => {
  const DEMO_ORG_ID = '0baa3831-ce88-482a-a661-fcb2dd80739d';
  const { organizationId } = useAuth();
  if (organizationId !== DEMO_ORG_ID) return null;
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '16px',
        right: '16px',
        zIndex: 9999,
        background: 'rgba(251, 191, 36, 0.12)',
        border: '1px solid rgba(251, 191, 36, 0.35)',
        borderRadius: '6px',
        padding: '4px 10px',
        fontSize: '11px',
        fontWeight: '500',
        color: 'rgba(251, 191, 36, 0.85)',
        letterSpacing: '0.06em',
        backdropFilter: 'blur(8px)',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      DEMO-UMGEBUNG
    </div>
  );
};

const MainLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  // Load sidebar state from localStorage with fallback
  useEffect(() => {
    try {
      const savedCollapsed = localStorage.getItem('clara-sidebar-collapsed') === 'true';
      setSidebarCollapsed(savedCollapsed);
    } catch (error) {
      console.warn('Failed to load sidebar state from localStorage:', error);
      setSidebarCollapsed(false);
    }
  }, []);

  const handleSidebarToggle = () => {
    const newCollapsed = !sidebarCollapsed;
    setSidebarCollapsed(newCollapsed);
    
    try {
      localStorage.setItem('clara-sidebar-collapsed', newCollapsed.toString());
    } catch (error) {
      console.warn('Failed to save sidebar state to localStorage:', error);
    }
  };

  const handleMobileMenuToggle = (isOpenOrEvent) => {
    if (typeof isOpenOrEvent === 'boolean') {
      setMobileMenuOpen(isOpenOrEvent);
    } else {
      // Handle click event - toggle current state
      setMobileMenuOpen(prev => !prev);
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 dark:bg-black dark:text-white">
      {/* Mobile Menu Button */}
      <MobileMenuButton 
        isOpen={mobileMenuOpen}
        onToggle={handleMobileMenuToggle}
      />
      
      {/* Sidebar */}
      <Sidebar
        isCollapsed={sidebarCollapsed}
        setIsCollapsed={setSidebarCollapsed}
        isMobile={mobileMenuOpen}
        setIsMobileMenuOpen={setMobileMenuOpen}
      />
      
      {/* Main Content */}
      <div className={`
        transition-all duration-300 ease-in-out
        ${sidebarCollapsed ? "ml-0 md:ml-16" : "ml-0 md:ml-64"}
      `}>
        
        {/* Content Area - NOW WITH OUTLET */}
        <main className="min-h-screen bg-white dark:bg-black">
          <Outlet />
        </main>
      </div>

      {/* Demo-Badge — nur für Demo-Organisation sichtbar, dezent unten rechts */}
      <DemoBadge />
      
      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-slate-900/20 dark:bg-gray-100/20 z-[40] md:hidden"
          onClick={() => handleMobileMenuToggle(false)}
        />
      )}
    </div>
  );
};

export default MainLayout;
